import { createFileRoute } from "@tanstack/react-router";
import { Wand2 } from "lucide-react";
import { AppShell } from "@/components/app-shell/AppShell";
import { PageHeader } from "@/components/common/PageHeader";
import { Panel } from "@/components/common/Card";

export const Route = createFileRoute("/form-designer")({
  component: FormDesignerPage,
});

function FormDesignerPage() {
  return (
    <AppShell title="Form Designer">
      <PageHeader
        eyebrow="tools · preview"
        title="Form Designer"
        description="Visually assemble a form, generate the markup, and ship it to your site without writing HTML."
      />
      <Panel className="p-16 text-center">
        <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-md bg-ember/10 ring-1 ring-ember/20">
          <Wand2 className="h-5 w-5 text-ember" />
        </div>
        <h2 className="font-display text-xl font-semibold text-zinc-100">
          Coming soon
        </h2>
        <p className="mx-auto mt-2 max-w-md text-sm text-zinc-500">
          A drag-and-drop builder that emits the exact HTML/JS snippet — with
          Turnstile pre-wired — for any of your forms.
        </p>
      </Panel>
    </AppShell>
  );
}
